module.exports = __webpack_public_path__ + "media/images/icon-close-a45c69c9d11020b811328f6a90fd0eb5.svg";